import { AgreementsSignatureForm, AgreementsSignaturesAllForm, AgreementsSignaturesVersionsForm } from '.'
import { ApiService } from '~/shared/api'
import { restGetList, sendForm, restCreate } from '~/shared/utils/decorators'
import type { ServiceRestGetList, ServiceRestCreate, ServiceCanSendForm } from '~/shared/interfaces'
import { toModel, toModels } from '~/shared/api/utils'
import type { AgreementsSignaturesListParams } from '~/interfaces/Agreements'
import { AgreementsSignatureModel } from '~/model/Agreements'

// eslint-disable-next-line
interface AgreementsSignaturesService
  extends ServiceRestGetList<AgreementsSignaturesListParams>,
    ServiceCanSendForm,
    ServiceRestCreate {}

@restGetList
@sendForm
@restCreate
// eslint-disable-next-line no-redeclare
class AgreementsSignaturesService extends ApiService {
  protected route: string = 'agreements/signatures'

  getListModel(params: AgreementsSignaturesListParams = {}): Promise<Array<AgreementsSignatureModel>> {
    return this.getList(params).then(toModels(AgreementsSignatureModel))
  }

  createModel(form: AgreementsSignatureForm): Promise<AgreementsSignatureModel> {
    return this.create(form).then(toModel(AgreementsSignatureModel))
  }

  createAllModel(
    form: AgreementsSignaturesAllForm = new AgreementsSignaturesAllForm()
  ): Promise<Array<AgreementsSignatureModel>> {
    return this.sendForm(form, `${this.prefix}/${this.route}/all`).then(toModels(AgreementsSignatureModel))
  }

  createVersionsModel(form: AgreementsSignaturesVersionsForm): Promise<Array<AgreementsSignatureModel>> {
    return this.sendForm(form, `${this.prefix}/${this.route}/versions`).then(toModels(AgreementsSignatureModel))
  }
}

export default AgreementsSignaturesService
